import React, {useEffect, useState} from 'react';
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import {Link, useNavigate} from "react-router-dom";
import noImage from "../../../font & image/image/noImages.png";
import toast from "react-hot-toast";
import {X} from "lucide-react";
import {BiSolidUserDetail} from "react-icons/bi";
import NavBar from "../../../Component/NavBar/NavBar";
import {AiFillProduct} from "react-icons/ai";


export default function AddToWonderful() {

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [wonderfulInputs, setWonderfulInputs] = useState({
        startTime: "",
        expiredTime: "",
        discount: 0
    });
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");

    const [products, setProducts] = useState([]);

    const [loading, setLoading] = useState(true);
    const [loadingAddWonder, setLoadingAddWonder] = useState({status: false, id: null});

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchProducts(currentPage);
    }, [currentPage, searchQuery]);

    const fetchProducts = (page) => {

        setLoading(true);
        apiRequests.get(`/api/product/get-all-admin`, {
            params: {
                page: page,
                limit: 10,
                search: searchQuery,
            }
        })
            .then((response) => {
                setProducts(response.data.data.docs);
                setTotalPages(response.data.data.totalPages);
            })
            .catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    navigate("/login");
                }
                console.error("Failed to fetch products");
            })
            .finally(() => setLoading(false));
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const toISO = (localDateTime) => {
        if (!localDateTime) return null;
        return new Date(localDateTime).toISOString();
    };
    const handleAddToWonderfulOffer = (productId) => {

        const payload = {
            productId,
            startTime: toISO(wonderfulInputs.startTime),
            expiredtime: toISO(wonderfulInputs.expiredTime),
            discount: Number(wonderfulInputs.discount)
        };

        setLoadingAddWonder({...loadingAddWonder, status: true, id: productId});

        apiRequests.post("/api/wonderful/v1/add", payload)
            .then(() => {
                toast.success("Product added to wonderful offers!");
                fetchProducts(1);
                setSelectedProduct(null);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                console.error("Failed to add product to wonderful offers", error);
                toast.error("Failed to add product to wonderful offers");
            }).finally(() => setLoadingAddWonder({...loadingAddWonder, status: false}));
    };


    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-2xl font-bold">
                    Add to wonderful products
                </h1>
                <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-700">
                    <X size={24}/>
                </button>
            </div>

            <NavBar
                item={[
                    {
                        icon: <AiFillProduct style={{fontSize: "22px"}}/>,
                        title: "All Products",
                    },
                ]}

                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-green-400 to-blue-500 text-white">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Image</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Name</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Category</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Price</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center">
                                    <Loading/>
                                </td>
                            </tr>
                        ) : products.length > 0 ? (
                            products.map((product) => {
                                    return (
                                        <tr key={product._id} className="hover:bg-gray-100 transition duration-200">
                                            <td className="px-6 py-4 text-nowrap">
                                                <img
                                                    src={product.images ? `https://api.goalafarin.com/${product.images[0]?.path}` : noImage}
                                                    alt={product.name?.en}
                                                    className="w-16 h-16 object-cover rounded-lg"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-800 font-medium text-nowrap"><Link
                                                to={`/product/${product._id}`}> {product.name?.en}</Link></td>
                                            <td className="px-6 py-4 text-gray-600 text-nowrap md:hidden">{product.category?.name}</td>
                                            <td className="px-6 py-4 text-gray-800 font-semibold text-nowrap md:hidden">{product.price} €</td>
                                            <td className="px-6 py-4 text-center space-x-4 text-nowrap">
                                                <button
                                                    className="text-green-600 hover:text-green-800 font-medium"
                                                    onClick={() => {
                                                        setSelectedProduct(product);
                                                        setWonderfulInputs({startTime: "", expiredTime: "", discount: 0});
                                                    }}
                                                >
                                                    Add to Special Offers
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                                    No products found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                    <div className="flex justify-center items-center mt-6 space-x-2">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === 1
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Prev
                        </button>

                        <span className="px-4">
                            Page {currentPage} of {totalPages}
                        </span>

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === totalPages
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>

            {selectedProduct && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h2 className="text-xl font-bold mb-4">
                            Add Offer for: {selectedProduct.name?.en}
                        </h2>

                        <div className="space-y-4">

                            <div>
                                <label className="text-sm font-medium">Start Time</label>
                                <input
                                    type="datetime-local"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={wonderfulInputs.startTime}
                                    onChange={(e) =>
                                        setWonderfulInputs({...wonderfulInputs, startTime: e.target.value})
                                    }
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Expired Time</label>
                                <input
                                    type="datetime-local"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={wonderfulInputs.expiredTime}
                                    onChange={(e) =>
                                        setWonderfulInputs({...wonderfulInputs, expiredTime: e.target.value})
                                    }
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Discount (%)</label>
                                <input
                                    type="number"
                                    className="w-full mt-1 px-3 py-2 border rounded-md"
                                    value={wonderfulInputs.discount}
                                    onChange={(e) =>
                                        setWonderfulInputs({...wonderfulInputs, discount: e.target.value})
                                    }
                                />
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded-md"
                                onClick={() => setSelectedProduct(null)}
                            >
                                Cancel
                            </button>

                            <button
                                className="px-4 py-2 bg-green-600 text-white rounded-md"
                                onClick={() => handleAddToWonderfulOffer(selectedProduct._id)}
                            >
                                {loadingAddWonder.status ? <Loading/> :
                                    'Save Offer'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}